import { useRef, useEffect } from 'preact/hooks';
import { useConfigStore } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';
import useFormCompletionPercentage from '../hooks/useFormCompletionPercentage';
import SvgIcon from './SvgIcon';
import { tryFocus } from '@/utils';
import { HandleTabIndex } from '@/features/elements';

export default function Progress() {
	const { activePage, formType } = useFormStore();
	const { properties, pageMap } = useConfigStore();
	const pageCount = Number(Object.keys(pageMap).pop());
	const formCompletionPercentage = useFormCompletionPercentage();

	const progressDivRef = useRef(null);

	useEffect(() => {
		if (activePage !== 1) {
			tryFocus(progressDivRef.current, 100);
		}
	}, [activePage]);

	if (properties.advanced?.showProgressbar && properties.advanced?.toggleDotview) {
		return (
			<HandleTabIndex
				className="progress dot-layout"
				id="progress"
				aria-label={`Page ${activePage} of ${pageCount}`}
				ref={progressDivRef}
			>
				{Object.keys(pageMap).map(pageKey => {
					const pageNumber = Number(pageKey);
					return (
						<div
							style={{ width: `${Math.floor(100 / (pageCount - 1))}%` }}
							className={`progress-wrap ${activePage > pageNumber ? 'completed' : ''} ${
								pageNumber === activePage ? 'active' : ''
							} ${pageNumber === pageCount ? 'last' : ''}`}
							data-pagecount={pageNumber}
						>
							<div className="progress-dot">
								{activePage > pageNumber ? (
									<SvgIcon
										icon="check"
										alt="check icon"
									/>
								) : (
									pageNumber
								)}
							</div>
						</div>
					);
				})}
			</HandleTabIndex>
		);
	}

	return (
		<div
			id="progress"
			className="progress bar-layout"
		>
			<HandleTabIndex
				ref={progressDivRef}
				id="progressBar"
				aria-label={`Page ${activePage} of ${pageCount}`}
				className="bar"
				style={{ width: `${formCompletionPercentage}%` }}
			></HandleTabIndex>
		</div>
	);
}
